import { Button, Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { usePayNowOAuthRedirect } from '@features/paynow/hooks/usePayNowOAuthRedirect'

import { ReactComponent as StripePaymentIllustration } from '../../../../../../assets/images/integrations/stripe-payment.svg'
import { CardPaymentsInfoCards } from '../CardPaymentsInfoCards'
import * as Styled from './styles'

interface CardPaymentsEmptyStateProps {
  isFreePlan: boolean
}

export const CardPaymentsEmptyState = ({ isFreePlan }: CardPaymentsEmptyStateProps): ReactElement => {
  const { t } = useTranslation()
  const { canRedirect, redirectToOAuth } = usePayNowOAuthRedirect()

  const disclaimerKey = isFreePlan
    ? 'settings.organization.card_payments.disclaimer.free_plan'
    : 'settings.organization.card_payments.disclaimer'

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Styled.Hero>
        <Flex alignItems="flex-start" flexDirection="column" flexGrow={1} gap={Spacing.S16}>
          <Text variant="display">{t('settings.organization.card_payments.hero.title')}</Text>
          <Text colorVariant="secondary">{t('settings.organization.card_payments.hero.description')}</Text>
          <Button disabled={!canRedirect} onClick={redirectToOAuth}>
            {t('settings.organization.card_payments.hero.cta')}
          </Button>
        </Flex>
        <Styled.IllustrationWrapper>
          <StripePaymentIllustration />
        </Styled.IllustrationWrapper>
      </Styled.Hero>

      <CardPaymentsInfoCards isFreePlan={isFreePlan} />

      <Text variant="bodySM" color={Color.Grey300} alignment="center">
        {t(disclaimerKey)}
      </Text>
    </Flex>
  )
}
